const React = require('react');
const { GatsbyContextProvider } = require('./src/store/GatsbyContext');
const { BreakpointsContextProvider } = require('./src/store/BreakpointsContext');

const Wrapper = ({ element, props }) => (
  <GatsbyContextProvider context={props.pageContext}>
    <BreakpointsContextProvider>{element}</BreakpointsContextProvider>
  </GatsbyContextProvider>
);

exports.Wrapper = Wrapper;
